'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _DropdownSelectRow = require('./DropdownSelectRow');

var _DropdownSelectRow2 = _interopRequireDefault(_DropdownSelectRow);

require('./DropdownSelect.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    DropdownSelectView: {
        displayName: 'DropdownSelectView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/DropdownSelect/default/DropdownSelectView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var DropdownSelectView = _wrapComponent('DropdownSelectView')(function (_Component) {
    (0, _inherits3.default)(DropdownSelectView, _Component);

    function DropdownSelectView() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, DropdownSelectView);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropdownSelectView.__proto__ || (0, _getPrototypeOf2.default)(DropdownSelectView)).call.apply(_ref, [this].concat(args))), _this), _this.renderItem = function (item, index) {
            var id = index,
                text = '';
            if ((typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) === 'object') {
                id = item[_this.props.idField];
                text = item[_this.props.textField];
            } else if (typeof item === 'string') {
                text = item;
            }

            return _react3.default.createElement(_DropdownSelectRow2.default, {
                key: index,
                id: id,
                selected: _this.props.selected === id,
                text: text,
                onClick: _this.props.handleChange
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(DropdownSelectView, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                title = _props.title,
                _props$items = _props.items,
                items = _props$items === undefined ? [] : _props$items,
                open = _props.open,
                handleBlur = _props.handleBlur,
                handleClick = _props.handleClick;

            var classText = open ? ' open' : '';
            return _react3.default.createElement(
                'div',
                {
                    className: 'dropdown dropdown-select btn-group' + classText,
                    id: this.props.id ? this.props.id : "dropdown",
                    onBlur: handleBlur
                },
                _react3.default.createElement(
                    'button',
                    {
                        type: 'button',
                        className: 'btn btn-default dropdown-toggle',
                        onClick: handleClick
                    },
                    _react3.default.createElement(
                        'div',
                        { className: 'dropdown-title' },
                        title,
                        _react3.default.createElement('span', { className: 'caret' })
                    )
                ),
                _react3.default.createElement(
                    'ul',
                    { className: 'dropdown-menu' },
                    items.map(this.renderItem)
                )
            );
        }
    }]);
    return DropdownSelectView;
}(_react2.Component));

exports.default = DropdownSelectView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DropdownSelect/default/DropdownSelectView.jsx
// module id = 1657
// module chunks = 0